export default __webpack_public_path__ + "static/media/secon2.bbbc7d6f.jpg";